<template>
  <tbody class="base-table-body">
    <slot />
  </tbody>
</template>

<script>
export default {
  name: "BaseTableBody",
};
</script>

<style lang="scss">
@import "./base-table-body.scss";
</style>
